import styled from 'styled-components'
import { Modal } from 'antd'
import { isMobile } from 'react-device-detect'
import { font, greys, borderRadius, fontFamily } from 'assets/themes/theme-default'

const AntModalStyled = styled(Modal)`
  .ant-modal-header {
    text-align: center;
    background-color: ${greys.light4};
    border-radius: ${borderRadius.sm};
  }
  .ant-modal-title {
    font-size: ${font.size.lgxxs};
    line-height: ${isMobile && 'normal'};
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
      ${fontFamily.bold};
  }
  .ant-modal-content {
    border-radius: ${borderRadius.sm};
    .ant-modal-body {
      padding: ${isMobile && '10px'};
    }
  }
  .ant-modal-footer {
    text-align: center;
  }
`

export default AntModalStyled
